/**
 * @module Sounds
 * @description
 */

var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
var Sound = require("react-native-sound");
var Promise = require("promise");

var SOUND_MAP = {
	"outgoing": [
		"/sounds/outgoing.mp3",
		"/sounds/outgoing.ogg"
	],
	"busy": [
		"/sounds/busy.mp3",
		"/sounds/busy.ogg"
	],
	"incoming": [
		"/sounds/incoming.mp3",
		"/sounds/incoming.ogg"
	],
	"incoming_2": [
		"/sounds/incoming_2.mp3",
		"/sounds/incoming_2.ogg"
	],
	"incoming_3": [
		"/sounds/incoming_3.mp3",
		"/sounds/incoming_3.ogg"
	],
	"incoming_4": [
		"/sounds/incoming_4.mp3",
		"/sounds/incoming_4.ogg"
	],
	"incoming_5": [
		"/sounds/incoming_5.mp3",
		"/sounds/incoming_5.ogg"
	],
	"incoming_6": [
		"/sounds/incoming_6.mp3",
		"/sounds/incoming_6.ogg"
	],
	"message": [
		"/sounds/message.mp3",
		"/sounds/message.ogg"
	],
	"alert": [
		"/sounds/alert.mp3",
		"/sounds/alert.ogg"
	]
};

var made_sounds = null;

module.exports = Model({
	name: "desktopsounds",
	init: init
});

function init() {
	var sounds = getSounds();
	this.push(sounds);
}

function getSounds() {
	if(!made_sounds)
		makeSounds();

	return made_sounds;
}

function makeSounds() {
	made_sounds = Object.keys(SOUND_MAP).reduce(function(result, name){
		var files = SOUND_MAP[name];

		var onResolve, onReject;

		var file = Sound.web ? files : files[0].slice(8);
		var sound = new Sound(file, Sound.MAIN_BUNDLE, onLoaded);

		result[name] = sound;
		result.loading[name] = new Promise(function(resolve, reject){
			onResolve = resolve;
			onReject = reject;
		});

		return result;

		function onLoaded(e) {
			if(e) onReject(e);
			else onResolve(e);
		}
	}, {
		loading: {}
	});
}
